import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { Observable, Subscription } from "rxjs";

import { TranslationGroup } from "../snackbar/abstract-snackbar.model";

import { AbstractAlertOptions } from "./abstract-alert.model";

export abstract class AbstractTranslatableAlertService {
	abstract open$(
		options: AbstractAlertOptions,
		translationGroups: TranslationGroup[],
		interpolateParams?: object
	): Observable<MatDialogRef<any, any>>;

	abstract open(
		options: AbstractAlertOptions,
		translationGroups: TranslationGroup[],
		interpolateParams?: object
	): Subscription;
}
